import { ThemeProvider } from "@mui/material";
import { AppRouter } from "./utils/Router";
import { getMuiTheme } from "./theme/theme";
import LanguageSwitch from "./components/LanguageSwitch/LanguageSwitch";
import Footer from "./layouts/Main/Footer";

import { useEffect } from "react";
import { requestNotificationPermission } from "./utils/firebaseConfig";
import { updateDeviceTokenAPI } from "./api/notification";
import { toast } from "react-toastify";

const App = () => {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          // console.log("Service Worker registered with scope:", registration.scope);
        })
        .catch((error) => {
          console.error("Service Worker registration failed:", error);
        });
    });
  }

  useEffect(() => {
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");
    if (!token || token === "undefined" || token === "null") return;

    const setupNotifications = async () => {
      try {
        if (typeof window !== "undefined" && "Notification" in window && Notification.permission === "granted") {
          const fcmToken = await requestNotificationPermission();
          const storedFcmToken = localStorage.getItem("fcmToken");
          if (storedFcmToken !== fcmToken) {
            await updateDeviceTokenAPI(fcmToken, "web");
            localStorage.setItem("fcmToken", fcmToken);
            console.log("FCM token registered with backend successfully");
          }
        }
      } catch (error) {
        console.error("FCM setup error on mount: ", error);
      }
    };
    setupNotifications();
  }, []);

  useEffect(() => {
    let unsubscribe: any;

    const startListener = async () => {
      try {
        const { onMessage } = await import("firebase/messaging");
        const { messaging } = await import("./utils/firebaseConfig");

        unsubscribe = onMessage(messaging, (payload: any) => {
          console.log("Foreground message received: ", payload);
          // Show toast alert
          const title = payload.notification?.title || payload.data?.title || "Notification";
          const body = payload.notification?.body || payload.data?.body || "";
          toast.info(`${title}: ${body}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

          // Dispatch event to refresh notification list/count
          const event = new CustomEvent("new_notification_received", { detail: payload });
          window.dispatchEvent(event);
        });
      } catch (err) {
        console.error("Error setting up foreground message listener: ", err);
      }
    };

    startListener();
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);



  return (
    <>
      <ThemeProvider theme={getMuiTheme()}>
        <AppRouter />
        {/* <LanguageSwitch /> */}
      </ThemeProvider>
    </>
  );
};

export default App;
